<style lang="scss">
.job-form {
  position: relative;

  h2 {
    font-size: 40px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 47px;
  }

  .error {
    position: relative !important;
    top: unset !important;
    right: unset !important;
    color: #F55668;
    font-size: 12px;
    letter-spacing: 0;
    line-height: 14px;
  }

  input[type="file"] {
    display: none;
  }
  input, textarea{
    border: 1px solid #D9D9D9;
    border-radius: 2px;
    background-color: #FFFFFF;
    &:focus{
      border-color: #004373;
    }
    color: #004373;
  }
  label {
    color: #5B5D64;
    font-size: 12px;
    letter-spacing: 0;
    line-height: 14px
  }

  textarea{
    width: 100%;
    height: 138px;
  }

  span.label {
    color: #354052;
    font-size: 11px;
    line-height: 22px;
    display: block;
    margin-bottom: 10px;
  }

  .filename {
    &:after {
      content: "x";
      margin-left: 8px;
      color: black;
      font-weight: 700;
      opacity: 0;
      transition: opacity 0.2s;
    }

    &:hover {
      cursor: pointer;

      &:after {
        opacity: 1;
      }
    }
  }

  label.file-input {
    display: block;
    text-align: start;
    padding: 16px;
    width: 100%;
    border: 1px solid #dce0e4;
    font-size: 16px;
    font-weight: 400;
    line-height: 22px;
    color: #004373;
    transition: border-color 0.2s;
    cursor: pointer;
    .blue {
      color: orange;

      &:hover {
        cursor: pointer;
        text-decoration: underline;
      }
    }

    &.highlight {
      border-color: orange;
    }
  }

  .spinner-background {
    display: none;
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;

    .spinner {
      position: absolute;
      z-index: 10;
      top: calc(50% - 30px);
      left: calc(50% - 30px);
      transform: translate(-50%, -50%);
    }
  }

  &.processing {
    form {
      opacity: 0.3;
    }

    .spinner-background {
      display: block;
    }
  }
}
</style>

<template>
  <div class="form job-form" :class="{'processing': processing}" id="jobForm">
    <h2 class="text-secondary">Solliciteer</h2>
    <p class="my-40 text-18">Wij zijn altijd geïnteresseerd in nieuwe collega’s die bedreven zijn of willen worden in het vak warehousing en logistiek.</p>
    <ValidationObserver v-slot="obs" ref="observer" tag="form" @submit.prevent="submit()">
      <div class="grid grid-cols-12 mb-16">
        <div class="col-span-5">
          <ValidationProvider ref="firstname" vid="firstname" rules="required|min:2" v-slot="props"
                              name="Voornaam" :slim="true">
            <div class="form-group position-relative" :class="props.classes">
              <label for="firstname">Voornaam</label>
              <input type="text" id="firstname" class="form-control block w-full" placeholder="Voornaam"
                     v-model="formData.firstname"/>
              <span class="error">{{ props.errors[0] }}</span>
            </div>
          </ValidationProvider>
        </div>
        <div class="col-start-7 col-span-5">
          <ValidationProvider ref="name" vid="name" rules="required|min:2" v-slot="props"
                              name="Achternaam" :slim="true">
            <div class="form-group position-relative" :class="props.classes">
              <label for="name">Achternaam</label>
              <input type="text" id="name" class="form-control block w-full" placeholder="Achternaam"
                     v-model="formData.name"/>
              <span class="error">{{ props.errors[0] }}</span>
            </div>
          </ValidationProvider>
        </div>
      </div>

      <div class="grid grid-cols-12 mb-16">
        <div class="col-span-5">
          <ValidationProvider ref="email" vid="email" rules="required|email" v-slot="props"
                              name="E-mail" :slim="true">
            <div class="form-group position-relative" :class="props.classes">
              <label for="email">E-mail</label>
              <input type="text" id="email" class="form-control block w-full" :placeholder="`E-mail`"
                     v-model="formData.email"/>
              <span class="error">{{ props.errors[0] }}</span>
            </div>
          </ValidationProvider>
        </div>
        <div class="col-start-7 col-span-5">
          <ValidationProvider ref="phone" vid="phone"
                              :rules="{ required: true, regex:/((?:\+|00)[17](?: |\-)?|(?:\+|00)[1-9]\d{0,2}(?: |\-)?|(?:\+|00)1\-\d{3}(?: |\-)?)?(0\d|\([0-9]{3}\)|[1-9]{0,3})(?:((?: |\-)[0-9]{2}){4}|((?:[0-9]{2}){4})|((?: |\-)[0-9]{3}(?: |\-)[0-9]{4})|([0-9]{7}))/}"
                              v-slot="props" name="Telefoon" :slim="true">
            <div class="form-group position-relative" :class="props.classes">
              <label for="phone">Telefoon</label>
              <input type="text" id="phone" class="form-control block w-full" :placeholder="`Telefoon`"
                     v-model="formData.phone"/>
              <span class="error">{{ props.errors[0] }}</span>
            </div>
          </ValidationProvider>
        </div>
      </div>

      <div class="grid grid-cols-12 mb-16">
        <div class="col-span-12">
          <span class="label">CV</span>
          <label id="drop-area" class="d-block file-input" for="cv" v-html="fileUploadText"></label>
          <input type="file" id="cv" ref="cv" @change="handleFileUpload()"
                 accept=".pdf,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/pdf"/>
          <span v-if="formData.cv.name" class="filename" @click="clearUploads()">{{ formData.cv.name }}</span>
        </div>
      </div>

      <div class="grid grid-cols-12 mb-16">
        <div class="col-span-12">
          <ValidationProvider ref="message" vid="message" rules="required|min:10" v-slot="props"
                              name="Bericht" :slim="true">
            <div class="form-group position-relative" :class="props.classes">
              <label for="message">Bericht</label>
              <textarea class="form-control flex-grow-1" id="message"
                        :placeholder="`Bericht`" v-model="formData.message"/>
              <span class="error error-top">{{ props.errors[0] }}</span>
            </div>
          </ValidationProvider>
        </div>
      </div>

      <div class="grid grid-cols-12 mb-16">
        <div class="col-span-12">
          <ValidationProvider ref="privacy-policy" vid="privacy-policy" :rules="{ required: { allowFalse: false } }"
                              v-slot="props"
                              name="Privacybeleid"
                              :slim="true">
            <div class="relative" :class="props.classes">
              <input type="checkbox" id="privacy-policy" v-model="formData.privacyPolicy"/>
              <label class="checkbox" :class="{'checked': formData.privacyPolicy}" for="privacy-policy"
                     v-html="privacyPolicyLinkText"></label>
              <span class="error error-top">{{ props.errors[0] }}</span>
            </div>
          </ValidationProvider>
        </div>
      </div>

      <span v-if="serverError" class="error error-large mb-20 d-block">{{ serverError }}</span>

      <button :disabled="obs.invalid" class="btn btn-primary btn-sm">Verstuur</button>
    </ValidationObserver>

    <div class="spinner-background">
      <div class="spinner">

      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    jobName: {
      type: String,
      required: true
    },
    privacyPolicyLink: {
      type: String,
      required: true
    },
  },

  data() {
    return {
      processing: false, //when posting the formData
      submitted: false, //when formData is successfully submitted
      serverError: null, //stores a server error (with optional message)

      formData: {
        firstname : "",
        name: "",
        email: "",
        phone: "",
        message: "",
        cv: "",
        privacyPolicy: null,
        job: this.jobName
      }
    }
  },

  mounted: function () {
    var self = this;

    let dropArea = document.getElementById('drop-area');
    ['dragenter', 'dragover', 'dragleave', 'drop'].forEach(eventName => {
      dropArea.addEventListener(eventName, preventDefaults, false)
    });

    function preventDefaults(e) {
      e.preventDefault()
      e.stopPropagation()
    }

    ['dragenter', 'dragover'].forEach(eventName => {
      dropArea.addEventListener(eventName, highlight, false)
    });

    ['dragleave', 'drop'].forEach(eventName => {
      dropArea.addEventListener(eventName, unhighlight, false)
    });

    function highlight(e) {
      dropArea.classList.add('highlight')
    }

    function unhighlight(e) {
      dropArea.classList.remove('highlight')
    }

    dropArea.addEventListener('drop', handleDrop, false)

    function handleDrop(e) {
      let dt = e.dataTransfer
      let files = dt.files


      self.$refs.cv.files = files;
      self.formData.cv = self.$refs.cv.files[0];
    }
  },

  computed: {
    fileUploadText: function () {
      var output = 'Sleep uw CV naar dit veld of kies een bestand (.pdf, .docx, .doc).';

      if ((output.match(/%s/g) || []).length == 2) { //only replace if 2 %s tags are present in the string
        var i = 0;
        var spanReplacements = ["<span class='blue'>", "</span>"]
        output = output.replace(/%s/g, function (matched) {
          return spanReplacements[i];
        });
      }

      return output;
    },

    privacyPolicyLinkText: function () {
      var output = 'Privacybeleid';

      if ((output.match(/%s/g) || []).length == 2) { //only replace if 2 %s tags are present in the string
        var i = 0;
        var anchorReplacements = ["<a href=\"" + this.privacyPolicyLink + "\">", "</a>"]
        output = output.replace(/%s/g, function (matched) {
          return anchorReplacements[i];
        });
      }

      return output;
    }
  },

  methods: {
    handleFileUpload() {
      this.formData.cv = this.$refs.cv.files[0];
    },

    clearUploads() {
      this.formData.cv = '';
      document.getElementById("cv").value = "";
    },

    async submit() {
      const isValid = await this.$refs.observer.validate();
      if (isValid) {
        this.processing = true;
        //prepare FormData object from our generic object
        var formData = new FormData();
        formData.append('firstname', this.formData.firstname);
        formData.append('name', this.formData.name);
        formData.append('email', this.formData.email);
        formData.append('phone', this.formData.phone);
        formData.append('message', this.formData.message);
        formData.append('cv', this.formData.cv);
        formData.append('job', this.formData.job);

        axios
            .post('/vacancies', formData, {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            })
            .then((response) => {
              if (response.data.hasOwnProperty('success')) this.done = true;

              document.getElementById('jobForm').innerHTML = "<h5>Bedankt voor uw sollicitatie. We nemen zo snel mogelijk contact met u op.</h5>"

              this.formData.firsntame = "";
              this.formData.name = "";
              this.formData.email = "";
              this.formData.phone = "";
              this.formData.message = "";
            })
            .catch((error) => {
              if (error.response.data.message == undefined) {
                this.serverError = error.response.data;
              } else {
                this.serverError = error.response.data.message;
              }
            })
            .finally(() => {
              this.processing = false;
            });
      }
    }
  },
}
</script>
